import { Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import TrafficClickIdentifierFilterCard from "./TrafficClickIdentifierFilter/TrafficClickIdentifierFilterCard";
import TrafficClickIdentifierTable from "./TrafficClickIdentifierTable/TrafficClickIdentifierTable";
import { useDispatch } from "react-redux";
import { MetaEntitiesEndPointLogic } from "../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import { selectUserData, setIsLoading } from "../../../../features/userSlice";
import { useSelector } from "react-redux";
import Page404 from "../../../Page404/Page403";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import SimpleBackdrop from "../../../BackDrop/BackDrop";

interface TrafficClickIdentifierProps {
  oauthTokenHeader: any;
}

const tableHeadings = {
  identifier: "Identifier Name",
  traffic_source: "Traffic Source",
  created: "Created on",
  created_by: "Created By",
  modified: "Last edited",
  modified_by: "Edited By",
};

const TrafficClickIdentifier = ({
  oauthTokenHeader,
}: TrafficClickIdentifierProps) => {
  const [selectedtrafficClickIdentifier, setSelectedtrafficClickIdentifier] =
    useState(null);
  const [trafficClickIdentifier, setTrafficClickIdentifier] = useState(null);
  const [selectedSource, setSelectedSource] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const response = useSelector(selectUserData);
  const hasViewTrafficClickIdentifierPermission = CheckPermissions(
    response?.data?.products?.admin,
    "meta_entities",
    "view_traffic_click_identifiers"
  );

  //traffic click identifier get data
  useEffect(() => {
    const fetchMetaEntitiesTrafficClickIdentifier = async () => {
      setIsLoading(true);
      setLoading(true);
      try {
        await MetaEntitiesEndPointLogic.getMetaTrafficClickIdentifiers(
          oauthTokenHeader,
          dispatch
        );
      } catch (error) {
        console.error("Error fetching Meta Entities:", error);
      } finally {
        setIsLoading(false);
        setLoading(false);
      }
    };
    if (oauthTokenHeader) {
      fetchMetaEntitiesTrafficClickIdentifier();
    }
  }, [oauthTokenHeader, dispatch]);
  if (!hasViewTrafficClickIdentifierPermission) {
    return <Page404 />;
  }
  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          <Paper
            sx={{
              boxShadow: "none",
              padding: "8px 16px 0px",
              borderEndEndRadius: "0px",
              borderBottomLeftRadius: "0px",
            }}
          >
            <Typography fontSize={24}>Traffic Click Identifier List</Typography>
            <TrafficClickIdentifierFilterCard />
          </Paper>
          <Paper
            sx={{
              boxShadow: "none",
              borderTopLeftRadius: "0px",
              borderTopRightRadius: "0px",
            }}
          >
            <TrafficClickIdentifierTable
              tableHeadings={tableHeadings}
              oauthTokenHeader={oauthTokenHeader}
              selectedtrafficClickIdentifier={selectedtrafficClickIdentifier}
              setSelectedtrafficClickIdentifier={
                setSelectedtrafficClickIdentifier
              }
              trafficClickIdentifier={trafficClickIdentifier}
              setTrafficClickIdentifier={setTrafficClickIdentifier}
              loading={loading}
              selectedSource={selectedSource}
              setSelectedSource={setSelectedSource}
            />
          </Paper>
        </>
      )}
    </>
  );
};

export default TrafficClickIdentifier;
